module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG2e04ab22b8b64c961356885edaae1bea.2e04ab22.png";